// @ts-nocheck

import { request } from '../../../context';
import type { ApiOptions } from '../../../context';
import type {
    GetCorporaHotWordsListByTypeQuery,
    GetCorporaHotWordsListByTypeParam,
    BaseResponseListCorporaCommonFoundResponse,
} from '../../../types';

/**
 * 查询所有热词
 *
 * @export
 * @tags 热词, 语料库
 * @link [GET] /corpora/hotWordsList/{type}
 * @param type
 */
export function getCorporaHotWordsListByType(
    options: ApiOptions<GetCorporaHotWordsListByTypeParam, GetCorporaHotWordsListByTypeQuery> & {
        segments: GetCorporaHotWordsListByTypeParam;
    } & { params: GetCorporaHotWordsListByTypeQuery }
): Promise<BaseResponseListCorporaCommonFoundResponse> {
    return request<never, GetCorporaHotWordsListByTypeParam, GetCorporaHotWordsListByTypeQuery>(
        '/corpora/hotWordsList/{type}',
        { ...options, method: 'get', __$requestCalleeName: 'getCorporaHotWordsListByType' }
    );
}

export const meta = [
    { tags: ['热词', '语料库'], path: '/corpora/hotWordsList/{type}', method: 'get' },
];
